const data: Array<any> = [
  {
    title: '雄关漫道真如铁 而今迈步从头越',
    time: '2020-04-21',
    id: '20200421',
  },
  {
    title: '我们最初的种子是……',
    time: '2020-05-10',
    id: '20200510',
  },
  {
    title: '母亲节活动“用叮咚er的方式给妈妈做一道菜” 评选结果新鲜出炉',
    time: '2020-05-17',
    id: '20200517',
  },
  {
    title: '父与子|叮咚爸爸们，父亲节快乐！',
    time: '2020-06-21',
    id: '20200621',
  },
  {
    title: '退伍不褪色 叮咚显本色',
    time: '2020-08-01',
    id: '20200801',
  },
  {
    title: '咚小记现场|探访叮咚直播间',
    time: '2020-08-27',
    id: '20200827',
  },
  {
    title: '让我成为你的眼',
    time: '2020-09-10',
    id: '20200910',
  },
  {
    title: '坚持比速度重要 | 叮咚绿@2020张江快乐跑',
    time: '2020-09-18',
    id: '20200918',
  },
  {
    title: '【乘风破浪，燃FUN叮咚】趣味运动会精彩集锦！',
    time: '2020-09-24',
    id: '20200924',
  },
  {
    title: '笔墨书团圆 才情话佳节 | 中秋活动精彩回顾',
    time: '2020-09-29',
    id: '20200929',
  },

  {
    title: '有故事的墙 | 总部文化墙全新亮相',
    time: '2020-10-12',
    id: '20201012',
  },
  {
    title: '发现属于叮咚的美 | 叮咚买菜首届员工摄影大赛评选结果新鲜出炉！',
    time: '2020-10-22',
    id: '20201022',
  },
  {
    title: '叮咚买菜总部消防演习图记 | “火”速行动 防患于未“燃”',
    time: '2020-11-09',
    id: '20201109',
  },
  {
    title: '成都雄起！西南地区，我们来了！',
    time: '2020-11-28',
    id: '20201128',
  },
  {
    title: '2021叮咚买菜新年日历 | 伴我一路前行',
    time: '2021-01-05',
    id: '20210105',
  },
  {
    title: '2021叮咚买菜年度品牌沙龙成功举行',
    time: '2021-01-08',
    id: '20210108',
  },
  {
    title: '冬季防火进行时 消防安全常伴心间',
    time: '2021-01-25',
    id: '20210125',
  },
  {
    title: '团市委送温暖 留沪过年热闹非凡',
    time: '2021-02-10',
    id: '20210210',
  },
  {
    title: '表白我眼里那个最美的她——女神节活动征集入选',
    time: '2021-03-08',
    id: '20210308',
  },
  {
    title: '传播青春正能量 壹佰米团委成立啦!',
    time: '2021-03-30',
    id: '20210330',
  },
  {
    title: '庆祝建党百年主题团建 叮咚青年重走乡村振兴之路',
    time: '2021-05-01',
    id: '20210501',
  },
  {
    title: '4水年华 初心犹在 “表白叮咚”留言板活动入选揭晓啦！',
    time: '2021-05-08',
    id: '20210508',
  },
  {
    title: '一周一课颁奖',
    time: '2021-06-30',
    id: '20210630',
  },
  {
    title: '2021叮咚买菜食品生鲜行业供应链生态峰会回顾',
    time: '2021-12-07',
    id: '20211207',
  },
  {
    title: '虎力全开 2022新春游园会精彩瞬间回顾',
    time: '2022-01-17',
    id: '20220117',
  },
];

export const innerData = data.reverse();
